enum OnlyDateFilter {
  Mondays = 'mondays',
  Sundays = 'sundays',
  Fridays = 'fridays'
}

export default OnlyDateFilter;
